import type { GeocodeResult } from '@travel-planner/shared';
import { api } from '../api/client';

// Markers are list items now (see ../lists/useListItems). This module only
// holds the reverse-geocode helper used when dropping a pin.
export function reverseGeocode(lat: number, lng: number): Promise<GeocodeResult> {
  return api.get<GeocodeResult>(`/geocode/reverse?lat=${lat}&lng=${lng}`);
}
